<template>
  <div v-if="showSimulation">
    <div class="o-toolbar">
      <div class="o-toolbar__left">
        <h2 class="c-heading-2">Betalen</h2>
        <p>SIMULATIE EXTERNE SERVICE</p>
        <p>&nbsp;</p>
      </div>
    </div>
    <footer class="c-container__footer">
      <div class="o-toolbar">
        <div class="o-toolbar__left">
          <button type="button" class="c-button c-button--error" @click="onFail">Betaling mislukt</button>
        </div>
        <div class="o-toolbar__right">
          <button type="button" class="c-button c-button--success" @click="onSuccess">Betaling gelukt</button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();

    return {
      showSimulation: computed(() => store.state.webshop.skipPayment),
      onFail() {
        store.commit("orders/setPaymentStatus", "failed");
        router.push({ name: "paymentFailed" });
      },
      async onSuccess() {
        await store.dispatch("orders/save");
        store.commit("orders/setPaymentStatus", "paid");
        router.push({ name: "paymentSuccess" });
      },
    };
  },
};
</script>
